import { AnyAction } from 'redux';
import { CustomizingState } from '../../types/redux';
import {
	CUSTOMIZING_LOADING_IN_PROGRESS,
	FETCH_CUSTOMIZING_SUCCESS,
} from '../actions/customizing';
import { LOGOUT_USER } from '../actions/mobivers';

const CUSTOMIZING_STATUS_UNDEFINED = 'CUSTOMIZING_STATUS_UNDEFINED';
export const CUSTOMIZING_STATUS_LOADING = 'CUSTOMIZING_STATUS_LOADING';
export const CUSTOMIZING_STATUS_COMPLETED = 'CUSTOMIZING_STATUS_COMPLETED';

const initialState: CustomizingState = {
	colors: {},
	name: null,
	status: CUSTOMIZING_STATUS_UNDEFINED,
	logoSrc: null,
};

export function customizingReducer(
	state: CustomizingState = initialState,
	action: AnyAction
): CustomizingState {
	switch (action.type) {
		case CUSTOMIZING_LOADING_IN_PROGRESS:
			return {
				...state,
				status: CUSTOMIZING_STATUS_LOADING,
			};
		case FETCH_CUSTOMIZING_SUCCESS:
			return {
				...initialState,
				...action.payload,
				status: CUSTOMIZING_STATUS_COMPLETED,
			};
		case LOGOUT_USER:
			return {
				...initialState,
				lastId: state.name,
			};
		default:
			return state;
	}
}
